import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Row, Cell, Dropdown } from 'sarsaparilla';
import { FacilityProps } from '../props';

const propTypes = {
  facilities: PropTypes.arrayOf(FacilityProps).isRequired,
  facilityId: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

const defaultProps = {
  facilityId: ''
};

export default class FacilitySelect extends PureComponent {
  constructor(props) {
    super(props);

    this.onChanged = this.onChanged.bind(this);
  }

  onChanged(value) {
    this.props.onChange(value);
  }

  render() {
    const { facilityId, facilities } = this.props;
    const options = facilities.map((facility) => ({ label: facility.name, value: facility.id }));

    return (
      <Row>
        <Cell>
          <Dropdown
            label="Select a Park"
            id="select-park"
            options={options}
            changeSelection={this.onChanged}
            currentSelection={facilityId} />
        </Cell>
      </Row>
    );
  }
}

FacilitySelect.propTypes = propTypes;
FacilitySelect.defaultProps = defaultProps;
